import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

interface OwnProps {
    extendedStyles?: ADIStickyCartImageStyles;
}

type Props = OwnProps & HasProductContext;

export interface ADIStickyCartImageStyles {
    imageWrapper?: InjectableCss;
    productImage?: ProductImageStyles;
}

export const adiStickyCartImageStyles: ADIStickyCartImageStyles = {
    imageWrapper: {
        css: css`
            width: 80px;
            height: 80px;
        `,
    },
    productImage: {
        image: {
            css: css`
                img {
                    min-width: 100%;
                }
            `,
        },
        linkWrappingImage: {
            css: css`
                width: 100%;
                height: 100%;
                pointer-events: none;
                cursor: default;
                img {
                    height: 100% !important;
                    object-fit: contain;
                }
            `,
        },
    },
};

const ADIStickyCartImage: FC<Props> = ({ productContext, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(adiStickyCartImageStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.imageWrapper}>
            <ProductImage extendedStyles={styles.productImage} product={productContext} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(ADIStickyCartImage),
    definition: {
        group: "Common",
        displayName: "ADI Sticky Cart Image",
    },
};

export default widgetModule;
